import type {CSSProperties} from 'react';
import {weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeProfileLook = 'profile-tester' | 'profile-voice';

/* Released Selling profile identity actions: the founder-tester Re-run onboarding block under the name field, and Preview my voice under the
   About you field. Each is a full-width flex block that centers its label (and, for the voice preview, a 14px glyph) with a hairline 0.5px
   border. The tester block has 10px by 12px padding, an 11px radius, 13px bold type, a 6px gap, the soft amber fill, the amber ink and the
   amber border. The voice block has 12px padding, a 12px radius, 13.5px bold type, an 8px gap, the soft accent fill, the label ink and the
   accent border. Held (the caller sets `disabled` while a reset or a draft runs), each takes the elevated fill, the tertiary ink and a default
   cursor, and keeps its border color. Each reads the exact legacy roles, so the shipped light amber ink rule keeps matching the serialized
   tester color. The caller owns the labels, the glyph, the handler and the layout. */
const TESTER_PADDING = '10px 12px', TESTER_RADIUS = 11, TESTER_FONT = 13, TESTER_GAP = 6;
const VOICE_PADDING = '12px', VOICE_RADIUS = 12, VOICE_FONT = 13.5, VOICE_GAP = 8;
const HAIRLINE = 0.5;

export function wedgeProfileStyle(look: WedgeProfileLook, disabled = false): CSSProperties {
  const r = wedgeExactRole;
  const tester = look === 'profile-tester';
  return {
    width: '100%', padding: tester ? TESTER_PADDING : VOICE_PADDING, borderRadius: tester ? TESTER_RADIUS : VOICE_RADIUS,
    background: disabled ? r('bgElev') : r(tester ? 'amberSoft' : 'accentSoft'),
    color: disabled ? r('labelTer') : r(tester ? 'amber' : 'label'),
    border: `${HAIRLINE}px solid ${r(tester ? 'amber' : 'accent')}`,
    fontSize: tester ? TESTER_FONT : VOICE_FONT, fontWeight: weight.bold, cursor: disabled ? 'default' : 'pointer',
    fontFamily: r('font'),
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: tester ? TESTER_GAP : VOICE_GAP,
  };
}
